<template>
  <div>
    <marketing-preferences
      v-if="showPreferences"
      v-model="checked.preferences"
      :preferences="preferences">
    </marketing-preferences>

    <fieldset v-if="showDmn">
        <input-checkbox
            :label="dmnMsg"
            v-model="checked.dmnPermission">
        </input-checkbox>
    </fieldset>
  </div>
</template>

<script>
  import inputCheckbox from './inputCheckbox'
  import marketingPreferences from './marketingPreferences'
  import { Source } from '../models/Source'

  export default {
    name: 'marketingCheckboxes',
    props: [
      'value',
      'showPreferences',
      'showDmn',
      'preferences'
    ],
    components: {
      inputCheckbox,
      marketingPreferences
    },
    data () {
      return {
        checked: this.value
      }
    },
    computed: {
      dmnMsg: function () {
        if (this.$root.dmnOptions.from === Source.partner) {
          return 'Receive hand-picked guides to the best events and coolest venues in your city from  DesignMyNight.com. No third parties, we promise! Read our <a target="_blank" href="https://designmynight.com/privacy-policy">privacy policy</a>.'
        } else {
          return 'Receive our hand-picked weekly guides to the best events and coolest venues in your city. No third parties, we promise! Read our <a target="_blank" href="https://designmynight.com/privacy-policy">privacy policy</a>.'
        }
      }
    },
    watch: {
      checked: function () {
        this.$emit('input', this.checked)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// marketingCheckboxes.vue?35dae1cc